export default __webpack_public_path__ + "static/image-600-e478f64777352d01cdb338c31e2286d7.png";